<template>
    <v-list three-line subheader v-if="items">
        <v-list-tile
                v-for="item in items"
                :key="item.code"
                @click="() => {}">
            <v-list-tile-content>
                <v-list-tile-title>{{ item.code }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
                <v-list-tile-sub-title v-if="type === 'tissues' && item.fragments">{{ $t('materials.creationForm.fields.fragments.label') }}: {{ item.fragments }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
                <v-btn :disabled="readOnly" icon ripple @click="handleDeleteButtonClick(item.code)">
                    <i class="fa fa-trash"></i>
                </v-btn>
            </v-list-tile-action>
        </v-list-tile>
    </v-list>
</template>

<script>
  export default {
    name: "materials-list",
    props: {
      items: {
        Type: Array
      },
      type: {
        Type: String
      },
      readOnly: {
        Type: Boolean
      }
    },
    methods: {
      handleDeleteButtonClick (code) {
        this.$emit('delete', code)
      }
    }
  }
</script>

<style scoped>

</style>